import * as React from 'react';
import { KeyboardBindingContext } from 'js/file_viewer/keyboard/context';
export const KeyboardBindingConnector = (props) => {
    const { keyboardBindings, name, scope } = props;
    // make sure these don't change
    const initialName = React.useRef(name);
    const initialScope = React.useRef(scope || false);
    const context = React.useContext(KeyboardBindingContext);
    React.useEffect(() => {
        const initialNameRef = initialName.current;
        const initialScopeRef = initialScope.current;
        context.registerKeyBindings(keyboardBindings, initialNameRef, initialScopeRef);
        return () => {
            context.unregisterKeyBindings(initialNameRef, initialScopeRef);
        };
    }, [context, keyboardBindings]);
    return null;
};
KeyboardBindingConnector.displayName = "KeyboardBindingConnector"
//# sourceMappingURL=keyboard_connector.preenvesnextjs.map
